interface ModalAction {
   text: string | null;
   // hook: (() => void) | null;
   action?: Function;
   redirect?: string | "back";
}

interface ModalState {
   open: boolean;
   headline: string | null;
   body?: string | HTMLElement | null; //you can pass a reference to a dom element and have it render in the modal for more complex elements
   actions?: {
      primary?: ModalAction;
      secondary?: ModalAction;
   };
   hideClose?: boolean;
}

export function useGlobalModal(
   initialState: ModalState = {
      open: false,
      headline: null,
      body: null,
      hideClose: false,
      actions: {
         primary: {
            text: null,
            redirect: "/",
         },
         secondary: {
            text: null,
            redirect: "/",
         },
      },
   }
) {
   // STATE ========================
   const modal = useState<ModalState>("modal", () => initialState);

   // SETTERS ========================
   const setModal = (newModal: ModalState) => {
      modal.value = newModal;
   };
   const clearModal = () => {
      modal.value = initialState;
   };

   // GETTERS ========================
   const getModal = computed(() => {
      return modal.value;
   });

   return {
      modal: getModal,
      setModal,
      clearModal,
   };
}
